type ShouldSkipCacheBridgeSyncArgs = {
	data?: unknown | null;
	fetchPolicy?: string;
};

export function shouldSkipCacheBridgeSync({
	data,
	fetchPolicy,
}: ShouldSkipCacheBridgeSyncArgs): string | null {
	// These are expected no-op cases, not bridge failures. Callers surface them
	// as skipped results without warning so diagnostics stay signal-heavy.
	if (fetchPolicy === 'no-cache') return 'no-cache';
	if (data == null) return 'data-missing';

	return null;
}
